module.exports = __webpack_public_path__ + "img/sld_inverter_green_dark.b76607d8.svg";